/* eslint-disable camelcase */
import { Module } from 'vuex'
import { RootState } from '../types'
import api from '@/api/axios'

export interface User {
  id: number
  name: string
  email: string
  role: string
  account_id: number
  account_type: 'Landlord' | 'Agency'
}

export interface AuthState {
  user: User | null
  access_token: string | null
  refresh_token: string | null
}

const auth: Module<AuthState, RootState> = {
  namespaced: true,

  state: (): AuthState => ({
    user: JSON.parse(localStorage.getItem('user') || 'null'),
    access_token: localStorage.getItem('access_token'),
    refresh_token: localStorage.getItem('refresh_token')
  }),

  getters: {
    isAuthenticated: (state) => !!state.access_token,
    currentUser: (state) => state.user,
    accountType: (state) => state.user?.account_type
  },

  mutations: {
    SET_AUTH (state, payload: { user: User; access_token: string; refresh_token: string }) {
      state.user = payload.user
      state.access_token = payload.access_token
      state.refresh_token = payload.refresh_token
      localStorage.setItem('user', JSON.stringify(payload.user))
      localStorage.setItem('access_token', payload.access_token)
      localStorage.setItem('refresh_token', payload.refresh_token)
    },
    CLEAR_AUTH (state) {
      state.user = null
      state.access_token = null
      state.refresh_token = null
      localStorage.removeItem('user')
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
    }
  },

  actions: {
    async login ({ commit }, credentials: { email: string; password: string }) {
      const { data } = await api.post('/auth/login', credentials)
      commit('SET_AUTH', {
        user: data.user,
        access_token: data.access_token,
        refresh_token: data.refresh_token
      })
      return data
    },

    async register (_, payload: Record<string, string>) {
      const { data } = await api.post('/auth/register', payload)
      return data
    },

    async forgotPassword (_, payload: { email: string }) {
      const { data } = await api.post('/auth/forgot-password', payload)
      return data
    },

    async resetPassword (_, payload: { token: string; email: string; password: string; password_confirmation: string }) {
      const { data } = await api.post('/auth/reset-password', payload)
      return data
    },

    logout ({ commit }) {
      commit('CLEAR_AUTH')
    }
  }
}

export default auth
